import { writable } from "svelte/store";

export let groupTableFilter = writable(null);